import { FloatingCTA } from 'components/floating-cta';
import { FormattedMessage } from 'react-intl';
import { Button } from '@hqo/ui-atoms';
import { isCreateVisitsEnabledSelector } from 'store/ui-metadata/selectors';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsActivityPane } from 'components/activity-pane-provider';

export const VisitsListV2Header: FC = () => {
  const navigate = useNavigate();
  const isActivityPane = useIsActivityPane();
  const handleNavigateToCreateVisit = useCallback(() => {
    // No `../`: this header renders in the pathless layout route, which already sits at `visits`.
    navigate('create');
  }, [navigate]);

  const isCreateVisitsEnabled = useSelector(isCreateVisitsEnabledSelector);

  return (
    <>
      <div className="hidden md:block bg-white border-b sticky top-0 z-10">
        <div className="max-w-[1600px] mx-auto px-4 md:px-12 pt-4 md:pt-6 pb-4 md:pb-6">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-semibold" data-cy="visits-view-page-v2-title">
              <FormattedMessage id="header.title" />
            </h1>
            {isCreateVisitsEnabled && (
              <Button
                onClick={handleNavigateToCreateVisit}
                data-cy="create-visit-desktop"
                data-testid="create-visit-desktop"
              >
                <FormattedMessage id="buttons.createVisit" />
              </Button>
            )}
          </div>
        </div>
      </div>
      {/* The create-visit affordance is host chrome: in the activity-center pane the record is a
          read-only detail, so drop the floating + (VIS-2032). */}
      {isCreateVisitsEnabled && !isActivityPane && (
        <FloatingCTA
          onClick={handleNavigateToCreateVisit}
          dataCy="floating-create-visit-button"
          dataTestId="floating-create-visit-button"
        />
      )}
    </>
  );
};
